/*
These functions make sure WordPress
and Foundation play nice together.
*/
window.codepoet = {};
jQuery(document).ready(function() {

    var $reserve_now = jQuery('#reserve_now_wrap');
    if (jQuery(window).scrollTop() > $reserve_now.height() + 300) {
        $reserve_now.addClass('moved');
    }

    jQuery('#root').on('scrollme.zf.trigger', function() {
        if (jQuery(window).scrollTop() > $reserve_now.height() + 300) {
            $reserve_now.addClass('moved');
        } else {
            $reserve_now.removeClass('moved');
        }
    });

    if (jQuery('.bxslider').length) {
        jQuery('.bxslider').bxSlider({
            mode: 'horizontal',
            controls: false,
            auto: true,
            pause: 5000
        });
    }

    jQuery('.page-template-template-forfaits .item_content .link a').on('click', function(event) {
        if (jQuery(this).attr('href') == '#') {
            event.preventDefault();
            jQuery('#reserve_now').trigger('click');
        }
    });

    if (jQuery('.logo-carousel').length) {
        jQuery('.logo-carousel').slick({
            dots: true,
            infinite: false,
            speed: 300,
            nextArrow: jQuery('#section6 .nextarrow'),
            prevArrow: jQuery('#section6 .prevarrow'),
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [{
                    breakpoint: 1920,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                }, {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false
                    }
                }
            ]
        });
    }


    if (jQuery('#items_carousel').length) {
        window.codepoet.slick = jQuery('#items_carousel').slick({
            dots: false,
            infinite: true,
            speed: 300,
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            draggable: false,
            swipeToSlide: false,
            touchMove: false,
            responsive: [{
                    breakpoint: 1024,
                    settings: {
                        infinite: true,
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        window.codepoet.slick_data = jQuery(window.codepoet.slick).slick('getSlick');

        jQuery('#right_navigation').on('click', function(event) {
            event.preventDefault();
            var nextIndex = jQuery(this).data('next'),
                maxItems = window.codepoet.slick_data.$slides.length,
                leftNextIndex = nextIndex - 1;

            if (nextIndex > maxItems - 1) {
                nextIndex = 0;
            }

            var nextSlickSlide = jQuery('#items_carousel .slick-slide').eq(nextIndex),
                nextSlide = jQuery(nextSlickSlide).find('.slide'),
                nextID = jQuery(nextSlide).data('id');

            jQuery(this).data('next', nextIndex + 1);
            jQuery(window.codepoet.slick).slick('slickGoTo', nextIndex);
            highlight_slide(nextSlide);
            show_content_box(nextID);

            console.log(nextIndex);

            jQuery('#left_navigation').data('next', leftNextIndex);
        });

        jQuery('#left_navigation').on('click', function(event) {
            event.preventDefault();
            var nextIndex = jQuery(this).data('next'),
                maxItems = window.codepoet.slick_data.$slides.length,
                rightNextIndex = nextIndex;

            var nextSlickSlide = jQuery('#items_carousel .slick-slide').eq(nextIndex),
                nextSlide = jQuery(nextSlickSlide).find('.slide'),
                nextID = jQuery(nextSlide).data('id');

            jQuery(window.codepoet.slick).slick('slickGoTo', nextIndex);
            if (nextIndex == 0) {
                nextIndex = maxItems;
            }
            jQuery(this).data('next', nextIndex - 1);
            highlight_slide(nextSlide);
            show_content_box(nextID);
            jQuery('#right_navigation').data('next', rightNextIndex + 1);
        });

        jQuery('#items_carousel .slide').on('click', function(event) {
            event.preventDefault();
            if (jQuery(this).hasClass('active')) {
                return false;
            }
            var currentID = jQuery(this).data('id'),
                currentSlide = jQuery(this),
                currentIndex = jQuery(this).parent().parent().data('slick-index');

            highlight_slide(currentSlide);
            show_content_box(currentID);
            jQuery('#left_navigation').data('next', currentIndex - 1);
            jQuery('#right_navigation').data('next', currentIndex + 1);
        });
    }

    if (jQuery('.acf-map').length) {
        jQuery('.acf-map').each(function() {
            map = new_map(jQuery(this));
        });
    }

    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

    // Makes sure last grid item floats left
    jQuery('.archive-grid .columns').last().addClass('end');

    // Adds Flex Video to YouTube and Vimeo Embeds
    jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
        if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
            jQuery(this).wrap("<div class='widescreen flex-video'/>");
        } else {
            jQuery(this).wrap("<div class='flex-video'/>");
        }
    });

});

function highlight_slide(nextSlide) {
    jQuery('#items_carousel .slide').removeClass('active');
    jQuery(nextSlide).addClass('active');
}

function show_content_box(nextID) {
    jQuery('#content_carousel .item_content').removeClass('active');
    jQuery('#item_content_' + nextID).addClass('active');
}

function new_map($el) {

    // var
    var $markers = $el.find('.marker');


    // vars
    var args = {
        zoom: 17,
        center: new google.maps.LatLng(0, 0),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        disableDefaultUI: true,
        styles: [{
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [{
                    "color": "#d3d3d3"
                }]
            },
            {
                "featureType": "transit",
                "stylers": [{
                        "color": "#808080"
                    },
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [{
                        "visibility": "on"
                    },
                    {
                        "color": "#b3b3b3"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [{
                    "color": "#ffffff"
                }]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry.fill",
                "stylers": [{
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "weight": 1.8
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "color": "#d7d7d7"
                }]
            },
            {
                "featureType": "poi",
                "elementType": "geometry.fill",
                "stylers": [{
                        "visibility": "on"
                    },
                    {
                        "color": "#ebebeb"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry",
                "stylers": [{
                    "color": "#a7a7a7"
                }]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.fill",
                "stylers": [{
                    "color": "#ffffff"
                }]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.fill",
                "stylers": [{
                    "color": "#ffffff"
                }]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [{
                        "visibility": "on"
                    },
                    {
                        "color": "#efefef"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [{
                    "color": "#696969"
                }]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [{
                        "visibility": "on"
                    },
                    {
                        "color": "#737373"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.icon",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "poi",
                "elementType": "labels",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.stroke",
                "stylers": [{
                    "color": "#d6d6d6"
                }]
            },
            {
                "featureType": "road",
                "elementType": "labels.icon",
                "stylers": [{
                    "visibility": "off"
                }]
            },
            {},
            {
                "featureType": "poi",
                "elementType": "geometry.fill",
                "stylers": [{
                    "color": "#dadada"
                }]
            }
        ]
    };


    // create map               
    var map = new google.maps.Map($el[0], args);


    // add a markers reference
    map.markers = [];


    // add markers
    $markers.each(function() {

        add_marker($(this), map);

    });


    // center map
    center_map(map);


    // return
    return map;

}

/*
 *  add_marker
 *
 *  This function will add a marker to the selected Google Map
 *
 *  @type    function
 *  @date    8/11/2013
 *  @since   4.3.0
 *
 *  @param   $marker (jQuery element)
 *  @param   map (Google Map object)
 *  @return  n/a
 */

function add_marker($marker, map) {

    // var
    var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

    // create marker
    var marker = new google.maps.Marker({
        position: latlng,
        map: map
    });

    // add to array
    map.markers.push(marker);

    // if marker contains HTML, add it to an infoWindow
    if ($marker.html()) {
        // create info window
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        // show info window when marker is clicked
        google.maps.event.addListener(marker, 'click', function() {

            infowindow.open(map, marker);

        });
    }

}

/*
 *  center_map
 *
 *  This function will center the map, showing all markers attached to this map
 *
 *  @type    function
 *  @date    8/11/2013
 *  @since   4.3.0
 *
 *  @param   map (Google Map object)
 *  @return  n/a
 */
function center_map(map) {

    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each(map.markers, function(i, marker) {

        var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

        bounds.extend(latlng);

    });

    // only 1 marker?
    if (map.markers.length == 1) {
        // set center of map
        map.setCenter(bounds.getCenter());
        map.setZoom(17);
    } else {
        // fit to bounds
        map.fitBounds(bounds);
    }

}